export default {
  CLEAR_SAVED_CAREERS_SEARCH: 'CLEAR_SAVED_CAREERS_SEARCH',
  UPDATE_SAVED_CAREERS_SEARCH: 'UPDATE_SAVED_CAREERS_SEARCH',
}
